import React from "react";
import { ReactFormBuilder } from "react-form-builder2";
import "react-form-builder2/dist/app.css";
import { Boxed } from '../../../components/Boxed.components';

const FormBuilder = ({ form, setForm }) => {
  const items = [
    {
      key: "TwoColumnRow",
    },
    {
      key: "ThreeColumnRow",
    },
    {
      key: "Header",
    },
    {
      key: "Label",
    },
    {
      key: "Dropdown",
    },
    {
      key: "TextInput",
    },
    {
      key: "NumberInput",
    },
    {
      key: "TextArea",
    },
    {
      key: "DatePicker",
    },
  ];

  const onLoad = async () => {
    return form;
  };
  return (
    <Boxed>
      <ReactFormBuilder
        toolbarItems={items}
        onLoad={onLoad}
        onPost={(data) => {
          setForm(data)
        }}
      />
    </Boxed>
  );
};

export default FormBuilder;
